import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    editSaleBusinessCardFlag: 0
  },
  getters: {},
  actions: {
    showDialogEditSaleBusinessCard: function (context, flag) {
      context.commit("show_Dialog_EditSaleBusinessCard", flag);
    }
  },
  mutations: {
    show_Dialog_EditSaleBusinessCard: function (state, flag) {
      state.editSaleBusinessCardFlag = flag;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_dialog.js